import PropTypes from 'prop-types';
import './Temporizador.scss';
import { useEffect, useState } from 'react';

const calculateTimeLeft = (target) => {
  const actualDate = new Date();
  const difference = target - actualDate;
  let timeLeft = {};

  if (difference > 0) {
    timeLeft = {
      days: Math.floor(difference / (1000 * 60 * 60 * 24)),
      hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
      minutes: Math.floor((difference / 1000 / 60) % 60),
      seconds: Math.floor((difference / 1000) % 60)
    };
  }

  return timeLeft;
};

const formatTime = ({ hours, minutes, seconds }) => {
  const pad = (n) => (n < 10 ? `0${n}` : n);
  return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
};

const Temporizador = ({ targetDate, updateView }) => {
  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft(targetDate));

  const timeString = formatTime(timeLeft);

  useEffect(() => {
    const timer = setTimeout(() => {
      setTimeLeft(calculateTimeLeft(targetDate));
    }, 1000);

    if (Object.keys(timeLeft).length === 0) {
      updateView(true);
    } else {
      updateView(false);
    }

    return () => clearTimeout(timer);
  }, [targetDate, timeLeft]);

  return (
    <div>
      {Object.keys(timeLeft).length ? (
        <div className="temporizador-container">
          <div className="name-time-home">
            <span className="temporizador-home">{timeString.split(':')[0]}</span>
            <span>Horas</span>
          </div>
          <span className="dots-temporizador">:</span>
          <div className="name-time-home">
            <span className="temporizador-home">{timeString.split(':')[1]}</span>
            <span>Min</span>
          </div>
          <span className="dots-temporizador">:</span>
          <div className="name-time-home">
            <span className="temporizador-home">{timeString.split(':')[2]}</span>
            <span>Seg</span>
          </div>
        </div>
      ) : (
        <div className="temporizador-container">
          <div className="name-time-home">
            <span className="temporizador-home">00</span>
            <span>Horas</span>
          </div>
          <span className="dots-temporizador">:</span>
          <div className="name-time-home">
            <span className="temporizador-home">00</span>
            <span>Min</span>
          </div>
          <span className="dots-temporizador">:</span>
          <div className="name-time-home">
            <span className="temporizador-home">00</span>
            <span>Seg</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default Temporizador;

Temporizador.propTypes = {
  updateView: PropTypes.func.isRequired,
  targetDate: PropTypes.number.isRequired
};
